import React, { ReactElement } from "react";
import classnames from "classnames";

import { showValue } from "../../table.helpers";

import "./CellDetails.scss";

interface CellDetailsProps {
  id: string;
  header: ReactElement | string;
  value?: ReactElement | string;
}

export const CellDetails = ({ id, header, value }: CellDetailsProps) => {
  return (
    <div
      className={classnames("cell-details", { [`cell-details--${id}`]: id })}
    >
      <div className="cell-details__header">{header}</div>
      <div className="cell-details__value">
        {showValue<ReactElement | string>(value)}
      </div>
    </div>
  );
};
